import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import { Group } from "@domain/group/group";
import { PrimaryBold, Small } from "@ui/components/containers/primary";
import { Row, row } from "@ui/components/layout";

interface ShareroomPricingProps extends React.HTMLAttributes<HTMLDivElement> {
	shareroom: Group;
}
export const ShareroomPricing: React.FC<ShareroomPricingProps> = ({ shareroom, ...htmlProps }) => {
	const {
		pricing: { priceInUserCurrency, subscriptionMode, userCurrency },
	} = shareroom;
	return (
		<Container {...htmlProps}>
			<Row gap={0} align="flex-end" justify="center">
				<StyledPrimarybold>
					{priceInUserCurrency} {userCurrency}
				</StyledPrimarybold>
				/<StyledSmall>{I18n.t(`shareroom.subscription.mode.${subscriptionMode}`)}</StyledSmall>
			</Row>
		</Container>
	);
};
const Container = styled.div`
	${({ theme }) => theme.containerStyles.roundedBlockStyle};
	background-color: ${({ theme }) => theme.colors.orange};
	color: ${({ theme }) => theme.colors.white};
	${row(0, "center", "center")};
	border: none;
	outline: none;
	padding: 5px 10px;
`;

const StyledPrimarybold = styled(PrimaryBold)`
	font-size: 0.75rem;
	color: #fff;
`;

const StyledSmall = styled(Small)`
	font-weight: 400;
	color: #fff;
`;
